var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8263 5.76251C11.2808 5.67355 11.1444 5.36163 11.0325 4.33744L10.8864 2.71418L10.679 4.34129C10.5734 5.42963 10.1703 5.68233 8.84847 5.7941L7.18793 5.8973L8.82654 5.96421C10.2554 6.03627 10.5865 6.34656 10.6752 7.40542L10.7649 9.02948L10.9481 7.38861C11.0826 6.22249 11.447 6.04988 12.8387 5.95072L14.4625 5.84423L12.8263 5.76251Z",
    fill: "#FFFEF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.2976 11.1794C24.1214 10.8815 23.6645 9.8368 23.2896 6.4065L22.8003 0.96982L22.1056 6.4194C21.7521 10.0645 20.402 10.9109 15.9748 11.2852L10.4133 11.6309L15.9014 11.855C20.687 12.0963 21.7958 13.1356 22.0931 16.6819L22.3933 22.1213L23.007 16.6256C23.4576 12.72 24.678 12.1419 29.3393 11.8098L34.7776 11.4531L29.2976 11.1794Z",
    fill: "#FFFEF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.4689 20.6763C11.0663 20.4805 10.766 19.7937 10.5195 17.5388L10.1979 13.965L9.74127 17.5473C9.50887 19.9434 8.62139 20.4998 5.71118 20.7459L2.05531 20.9731L5.6629 21.1204C8.80872 21.279 9.53763 21.9622 9.73303 24.2934L9.93038 27.869L10.3338 24.2564C10.63 21.689 11.4322 21.309 14.4963 21.0907L18.0712 20.8562L14.4689 20.6763Z",
    fill: "#FFFEF2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsGroup);
export default __webpack_public_path__ + "static/media/starsGroup.bf93c29f9b6750a2ed4e7a8a4f17c24b.svg";
export { ForwardRef as ReactComponent };